import PermissionMatrix, { permissionObject } from '../../../components/PermissionMatrix';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import axios from 'axios';
import { CiEdit } from 'react-icons/ci';



import { AiOutlineBranches } from 'react-icons/ai';
import { BsFillPersonCheckFill } from 'react-icons/bs';
import { RiArrowDropDownLine, RiBillLine, RiChatFollowUpLine, RiCustomerServiceLine } from 'react-icons/ri';
import { MdOutlineInventory, MdOutlineSupportAgent } from 'react-icons/md';
import { MdAccountBalance, MdAssignmentReturn } from 'react-icons/md';
import { FaShoppingCart, FaFileAlt, FaSearch } from "react-icons/fa";
import { FaCartFlatbedSuitcase } from 'react-icons/fa6';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { BiPurchaseTagAlt, BiSolidReport } from 'react-icons/bi';
import { MdOutlinePayments } from "react-icons/md";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { MdEventNote } from 'react-icons/md';
import { FaSortAmountUp } from "react-icons/fa";
import { IoIosCreate } from "react-icons/io";
import { MdOutlineInventory2 } from "react-icons/md";
import { MdOutlineAccountBalance } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { GiConfirmed } from "react-icons/gi";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdPersonAddAlt1 } from "react-icons/md";
import { MdOpenInNew, MdOutlinePostAdd } from "react-icons/md";
import { BsPostcard } from "react-icons/bs";

import { PiBank } from "react-icons/pi";
import { AiOutlineIssuesClose } from "react-icons/ai";
import { CgShutterstock } from "react-icons/cg";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { IoReceiptOutline } from "react-icons/io5";
import { TbReport } from "react-icons/tb";
import { FaBoxTissue } from "react-icons/fa6";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { FaClipboardList } from "react-icons/fa";
import { GrUserManager } from "react-icons/gr";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoDocumentOutline } from "react-icons/io5"


import { TbReportSearch } from "react-icons/tb";
import { FaClipboardUser } from "react-icons/fa6";
import { MdFollowTheSigns } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { IoCall } from "react-icons/io5";

import { TfiHeadphoneAlt } from "react-icons/tfi";
import { RiCustomerServiceFill } from "react-icons/ri";
import { FaMoneyBill } from "react-icons/fa";

import { BsPersonBadge } from 'react-icons/bs';


import { GrSchedulePlay } from "react-icons/gr";
import { TbBrandProducthunt } from "react-icons/tb";
import { FaUserLock } from "react-icons/fa";
import { IoTimerOutline } from "react-icons/io5";
import { CiViewTimeline } from "react-icons/ci";
import { SiStatuspage } from "react-icons/si";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { SiMaterialdesignicons } from "react-icons/si";
import { FaDatabase } from "react-icons/fa";
import { PiPhoneCallBold } from "react-icons/pi";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { RiAdminLine } from "react-icons/ri";
import { LuHeadset } from "react-icons/lu";
import { RiRedPacketFill } from "react-icons/ri";
import { HiTemplate } from "react-icons/hi";
import { GoChecklist } from "react-icons/go";
import { PiMapPinAreaDuotone } from "react-icons/pi";
import { HiOutlinePhoneMissedCall } from "react-icons/hi"
import { TbReportMedical } from "react-icons/tb";
import { TbReportMoney } from "react-icons/tb";
import { TbReportAnalytics } from "react-icons/tb";
import { GrLink } from "react-icons/gr";
import { FaCentercode } from "react-icons/fa";
import { GiBlackBook } from "react-icons/gi";
import { MdOutlinePageview } from "react-icons/md";
import { RiContractFill } from "react-icons/ri";
import { GiExpense } from "react-icons/gi";
import { FcSimCardChip } from "react-icons/fc";
import { IoCardSharp } from "react-icons/io5";
import { FaRegCreditCard } from "react-icons/fa";
import { BsCashStack } from "react-icons/bs";
import { RiBankFill } from "react-icons/ri";
import { TiShoppingCart } from "react-icons/ti";

const UserRight = () => {
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const [user, setUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [access, setAccess] = useState(null);
  const [legacyBranch, setLegacyBranch] = useState('');
  const [permissions, setPermissions] = useState({});
  const [legacyReady, setLegacyReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [accessError, setAccessError] = useState('');
  const [assignment, setAssignment] = useState(null);
  const [removeBranch, setRemoveBranch] = useState(null);
  const requestVersion = useRef(0);
  const permissionVersion = useRef(0);
  const invalidateAccessRequests = useCallback(() => {
    ++requestVersion.current;
    ++permissionVersion.current;
  }, []);
  const employee = user.find(item => item.emp_id === selectedUser);
  const employeeId = employee?.id; // Existing branch-role APIs use the selected staff record's PK.
  const companyID = localStorage.getItem('companyID');
  const showToast = (message, bg = 'success') => setToast({ show: true, message, bg });
  const apiError = error => error.response?.data?.error || error.response?.data?.message || error.message;

  useEffect(() => {
    let live = true;
    Promise.all([
      axios.get('https://api.skyguard.group/api/fetch-employee', { params: { official_staff: 1 } }),
      axios.get('https://api.skyguard.group/api/fetch-branch'),
      axios.get('https://api.skyguard.group/api/fetch-role')
    ]).then(([employees, branchList, roleList]) => {
      if (!live) return;
      setUser((employees.data.result || []).filter(emp =>
        typeof emp.emp_id === 'string' && emp.emp_id.trim() !== '' && emp.emp_id.startsWith('SERP')));
      setBranches(branchList.data.result || []);
      setRoles(roleList.data.result || []);
    }).catch(error => { if (live) showToast(apiError(error), 'danger'); });
    return () => { live = false; };
  }, []);

  const refreshAccess = async id => {
    const version = ++requestVersion.current;
    ++permissionVersion.current;
    setAccess(null);
    setPermissions({});
    setLegacyReady(false);
    setAccessError('');
    const response = await axios.get('https://api.skyguard.group/api/employees/' + id + '/branch-roles');
    if (version === requestVersion.current) setAccess({ ...response.data, employee_id: Number(id) });
  };

  useEffect(() => {
    if (!employeeId) { setAccess(null); setPermissions({}); setLegacyReady(false); return; }
    setBusy(true);
    refreshAccess(employeeId).catch(error => { setAccessError(apiError(error)); showToast(apiError(error), 'danger'); })
      .finally(() => setBusy(false));
    return invalidateAccessRequests;
  }, [employeeId, invalidateAccessRequests]);

  const accessRows = access && Number(access.employee_id) === Number(employeeId) ? access.result || [] : [];
  const memberships = access && Number(access.employee_id) === Number(employeeId) ? access.branches || [] : [];
  const legacyIds = useMemo(() => {
    if (!access || Number(access.employee_id) !== Number(employeeId)) return [];
    return (access.branches || []).filter(id => !(access.result || []).some(row => Number(row.branch_id) === Number(id)));
  }, [access, employeeId]);
  const legacyBranches = branches.filter(branch => legacyIds.includes(Number(branch.id)));
  const displayIds = [...new Set([...memberships, ...accessRows.map(row => Number(row.branch_id))])];
  const branchName = id => branches.find(branch => Number(branch.id) === Number(id))?.name || 'Branch ' + id;

  useEffect(() => {
    const version = ++permissionVersion.current;
    setPermissions({});
    setLegacyReady(false);
    if (!access || !employee?.emp_id || !legacyIds.length) return;
    if (!legacyIds.includes(Number(legacyBranch))) {
      setLegacyBranch(String(legacyIds[0]));
      return;
    }
    let live = true;
    axios.get('https://api.skyguard.group/api/user-permissions/' + encodeURIComponent(employee.emp_id),
      { params: { branch_id: legacyBranch } })
      .then(response => {
        if (live && version === permissionVersion.current) {
          setPermissions(permissionObject(response.data.permissions));
          setLegacyReady(true);
        }
      }).catch(error => { if (live && version === permissionVersion.current) showToast(apiError(error), 'danger'); });
    return () => { live = false; };
  }, [access, selectedUser, legacyBranch, employee?.emp_id, legacyIds]);

  const handleSavePermissions = async () => {
    if (!legacyReady || !employee?.emp_id || !legacyIds.includes(Number(legacyBranch))) return;
    setBusy(true);
    try {
      // Only an explicitly selected, accessible unmapped branch may use legacy data.
      // Membership is always changed through the branch-role endpoints.
      const response = await axios.post('https://api.skyguard.group/api/user-permissions', {
        employeeId: employee.emp_id, branch_id: Number(legacyBranch), permissions
      });
      showToast(response.data.message);
    } catch (error) { showToast(apiError(error), 'danger'); }
    finally { setBusy(false); }
  };

  const saveAssignment = async event => {
    event.preventDefault();
    if (!assignment?.branch_id || !assignment.role_id || !employee) return;
    setBusy(true);
    ++permissionVersion.current;
    setPermissions({}); setLegacyReady(false);
    try {
      const base = 'https://api.skyguard.group/api/employees/' + employee.id + '/branch-roles';
      if (assignment.mode === 'change') {
        await axios.put(base + '/' + assignment.branch_id, { role_id: Number(assignment.role_id) });
      } else {
        await axios.post(base, { branch_id: Number(assignment.branch_id), role_id: Number(assignment.role_id) });
      }
      setAssignment(null);
      await refreshAccess(employee.id);
      showToast('Branch access updated successfully');
    } catch (error) {
      showToast(apiError(error), 'danger');
      try { await refreshAccess(employee.id); } catch (refreshError) { setAccessError(apiError(refreshError)); }
    } finally { setBusy(false); }
  };

  const confirmRemove = async () => {
    setBusy(true);
    ++permissionVersion.current;
    setPermissions({}); setLegacyReady(false);
    try {
      await axios.delete('https://api.skyguard.group/api/employees/' + employee.id + '/branch-roles/' + removeBranch);
      setRemoveBranch(null);
      await refreshAccess(employee.id);
      showToast('Branch access removed');
    } catch (error) {
      showToast(apiError(error), 'danger');
      try { await refreshAccess(employee.id); } catch (refreshError) { setAccessError(apiError(refreshError)); }
    } finally { setBusy(false); }
  };

  const availableBranches = branches.filter(branch =>
    (!companyID || Number(branch.company_id) === Number(companyID)) &&
    !accessRows.some(row => Number(row.branch_id) === Number(branch.id) && row.status === 'ACTIVE'));
  const assignmentCompany = branches.find(branch => Number(branch.id) === Number(assignment?.branch_id))?.company_id;
  const roleChoices = roles.filter(role => assignmentCompany && Number(role.company_id) === Number(assignmentCompany));

  return <div className="main-section">
    <div className="container-fluid dashboard-wrapper p-3 bg-body-secondary">
      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })} />
      <h3 className="my-3 fw-bold fs-5 golos">User Right</h3>
      <div className="container"><div className="row justify-content-center"><div className="col-12 col-sm-10 col-md-8 col-lg-10">
        <div className="card p-3 mt-4">
          <label className="form-label">Employee</label>
          <select className="form-control" value={selectedUser} disabled={busy} onChange={event => {
            ++requestVersion.current; ++permissionVersion.current;
            setSelectedUser(event.target.value); setAccess(null); setLegacyBranch('');
            setPermissions({}); setLegacyReady(false); setAssignment(null); setRemoveBranch(null);
          }}>
            <option value="">Select Employee</option>
            {user.map(emp => <option key={emp.emp_id} value={emp.emp_id}>{[emp.first, emp.middle, emp.last].filter(Boolean).join(' ')} ({emp.emp_id.trim()})</option>)}
          </select>
          {busy && <p className="mt-3" role="status">Loading / saving branch access?</p>}
          {accessError && <div className="alert alert-danger mt-3">{accessError}</div>}
          {access && <>
            <div className="table-responsive mt-4"><table className="table table-bordered table-striped align-middle">
              <thead className="table-info"><tr><th>Branch</th><th>Role / Access Type</th><th>Action</th></tr></thead>
              <tbody>{displayIds.length ? displayIds.map(id => {
                const mapping = accessRows.find(row => Number(row.branch_id) === Number(id));
                const revoked = mapping?.status === 'REVOKED';
                const active = mapping?.status === 'ACTIVE';
                const legacy = !mapping && memberships.includes(Number(id));
                return <tr key={id}><td>{branchName(id)}</td>
                  <td>{revoked ? 'Access revoked' : active ? (mapping.role_name || 'Assigned role unavailable') : legacy ? 'Legacy Permissions' : 'Access unavailable'}</td>
                  <td className="d-flex gap-2 flex-wrap">
                    {(active || legacy) && <button type="button" className="btn btn-outline-primary btn-sm" disabled={busy}
                      onClick={() => setAssignment({ mode: active ? 'change' : 'grant', branch_id: String(id), role_id: active ? String(mapping.role_id) : '' })}>
                      {active ? 'Change Role' : 'Assign Role'}</button>}
                    {(active || legacy) && <button type="button" className="btn btn-outline-danger btn-sm" disabled={busy} onClick={() => setRemoveBranch(id)}>Remove Access</button>}
                    {revoked && <button type="button" className="btn btn-outline-primary btn-sm" disabled={busy}
                      onClick={() => setAssignment({ mode: 'grant', branch_id: String(id), role_id: '' })}>Regrant Access</button>}
                  </td></tr>;
              }) : <tr><td colSpan="3">No branch access</td></tr>}</tbody>
            </table></div>
            <button type="button" className="btn btn-success align-self-start" disabled={busy}
              onClick={() => setAssignment({ mode: 'add', branch_id: '', role_id: '' })}><AiOutlinePlusCircle /> Add Branch Access</button>
            {assignment && <form onSubmit={saveAssignment} className="border rounded p-3 mt-3">
              <h5>{assignment.mode === 'change' ? 'Change Role' : 'Add Branch Access'}</h5>
              <label className="form-label">Branch</label>
              <select className="form-control mb-3" required value={assignment.branch_id} disabled={busy || assignment.mode !== 'add'}
                onChange={event => setAssignment({ ...assignment, branch_id: event.target.value, role_id: '' })}>
                <option value="">Select Branch</option>
                {(assignment.mode === 'add' ? availableBranches : branches.filter(branch => Number(branch.id) === Number(assignment.branch_id)))
                  .map(branch => <option key={branch.id} value={branch.id}>{branch.name}</option>)}
              </select>
              <label className="form-label">Role</label>
              <select className="form-control mb-3" required value={assignment.role_id} disabled={busy || !assignment.branch_id}
                onChange={event => setAssignment({ ...assignment, role_id: event.target.value })}>
                <option value="">Select Role</option>
                {roleChoices.map(role => <option key={role.id} value={role.id}>{role.department} ? {role.role}</option>)}
              </select>
              <button className="btn btn-primary me-2" disabled={busy}>Save</button>
              <button type="button" className="btn btn-secondary" disabled={busy} onClick={() => setAssignment(null)}>Cancel</button>
            </form>}
            {legacyBranches.length > 0 && employee?.emp_id && <div className="mt-4 border-top pt-3">
              <h5>Legacy Permissions</h5>
              <p className="text-muted">These employee permissions are shared by accessible legacy branches. Assigned roles use their own current permissions.</p>
              <label className="form-label">Legacy Branch</label>
              <select className="form-control" value={legacyBranch} disabled={busy} onChange={event => {
                ++permissionVersion.current; setLegacyReady(false); setPermissions({}); setLegacyBranch(event.target.value);
              }}>{legacyBranches.map(branch => <option key={branch.id} value={branch.id}>{branch.name}</option>)}</select>
              {legacyReady ? <>
                <fieldset disabled={busy}>
                  <PermissionMatrix key={selectedUser + ':' + legacyBranch} config={SIDEBAR_CONFIG} permissions={permissions}
                    setPermissions={setPermissions} branches={legacyBranches} />
                </fieldset>
                <button type="button" className="btn btn-primary mt-3" disabled={busy} onClick={handleSavePermissions}>Save Legacy Permissions</button>
              </> : <p className="mt-3">Legacy permissions are unavailable until loaded.</p>}
            </div>}
            {legacyBranches.length > 0 && !employee?.emp_id && <p className="mt-3">Legacy permissions need an employee code. Assign a role to manage access for this employee.</p>}
          </>}
        </div>
      </div></div></div>
      {removeBranch !== null && <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog" aria-modal="true" aria-label="Confirm Remove Access">
        <div className="modal-dialog"><div className="modal-content">
          <div className="modal-header"><h5 className="modal-title">Confirm Remove Access</h5></div>
          <div className="modal-body">Remove access to {branchName(removeBranch)}? This branch will remain revoked until explicitly regranted.</div>
          <div className="modal-footer">
            <button className="btn btn-secondary" disabled={busy} onClick={() => setRemoveBranch(null)}>Cancel</button>
            <button className="btn btn-danger" disabled={busy} onClick={confirmRemove}>Remove Access</button>
          </div>
        </div></div>
      </div>}
    </div>
  </div>;
};

export default UserRight





export const SIDEBAR_CONFIG = [
  {
    key: "admin",
    label: "Branch",
    icon: BsPersonBadge,
    menus: [
      // { label: "Branches", path: "/admin/branches" },
    ],
  },
  {
    key: "inventory",
    label: "Inventory",
    icon: MdOutlineInventory2,
    menus: [
       { label: "Add Inventory", path: "/admin/inventory",icon:MdOutlineInventory },
     { label: "Material Requistion", path: "/admin/po-requistion",icon:VscGitPullRequestGoToChanges },
    { label: "Material issue", path: "/admin/materail-issue" ,icon:AiOutlineIssuesClose },
       { label: "Material Return", path: "/admin/material-receipt",icon:IoReceiptOutline },
    { label: "Stock Transfer", path: "/admin/stock-transfer" },
    { label: "Report", path: "/admin/inventory-report",icon:TbReport },
   { label: "Godown", path: "/admin/godown",icon:FaBoxTissue  },
    { label: "Sale Order", path: "/admin/manage-order", icon: TiShoppingCart },
         { label: " Document", path: "/admin/inventory-document", icon: GiBlackBook },
  
    ],
  },
  {
    key: "account",
    label: "Account",
    icon: MdAccountBalance,
    menus: [
      { label: "Party", path: "/admin/party", icon: MdOutlineInventory },
      { label: "Account", path: "/admin/accounts", icon: MdAccountBalance },
      { label: "Bank Payment", path: "/admin/bank-payment", icon: RiBankFill },
           { label: "Cash Payment", path: "/admin/cash-payment", icon: BsCashStack },
           { label: "Bank Receipt", path: "/admin/bank-receipt", icon: RiBankFill },
           { label: "Cash Receipt", path: "/admin/cash-receipt", icon: BsCashStack },
           { label: "Credit Note", path: "/admin/credit-note", icon: FaRegCreditCard },
           { label: "Debit Note", path: "/admin/debit-note", icon: IoCardSharp },
           { label: "Journal Voucher", path: "/admin/journal-voucher", icon: FcSimCardChip },
           { label: "Expense Voucher", path: "/admin/expnse-voucher", icon: GiExpense },
           { label: "Contra Voucher", path: "/admin/contra-voucher", icon: RiContractFill },
           { label: "Account Report", path: "/admin/account-report", icon: TbReport },
             { label: " Document", path: "/admin/account-document", icon: GiBlackBook },
                 { label: "Bank Re-concilation", path: "/admin/bank-reconcilation", icon: GiBlackBook }
    ],
  },
  {
    key: "hrms",
    label: "HRMS",
    icon: GrUserManager,
    menus: [
      { label: "Add Employee", path: "/admin/add-employee", icon: AiOutlineUserAdd },
      { label: "Add Holiday", path: "/admin/add-holiday", icon: SlCalender },
      { label: "Leave Request", path: "/admin/leave-request", icon: GiConfirmed },
      { label: "Loan", path: "/admin/loan", icon: RiMoneyRupeeCircleLine },
      { label: "Notice Board", path: "/admin/notice-board", icon: FaClipboardList },
      { label: "Documents", path: "/admin/hrms-document", icon: IoDocumentOutline },
       { label: "Report", path: "/admin/hrms-report", icon: TbReport },
    ],
  },
    {
      key: "recruitment",
      label: "Recruitment",
      icon: BsPostcard,
      menus: [
        { label: "Post Openings ", path: "/admin/post-openings", icon: MdOpenInNew },
        { label: "Applications", path: "/admin/my-applications", icon: MdOutlinePostAdd },
      ],
    },
  {
    key: "attendence",
    label: "Time Attendance ",
    icon: BsFillPersonCheckFill,
    menus: [
      { label: "Leave Master", path: "/admin/leave-master", icon: MdOutlineFreeCancellation },
      { label: "Leave", path: "/admin/leave-application", icon: MdEventNote },
      { label: "Daily Attendance", path: "/admin/emp-attendence", icon: BsFillPersonCheckFill },
      { label: "Report", path: "/admin/attendence-report", icon: BiSolidReport },
    ],
  }, {
    key: "payroll",
    label: "Pay Roll",
    icon: MdOutlinePayments,
    menus: [
      { label: "Pay Head ", path: "/admin/pay-head", icon: MdOutlinePayments },
      { label: "PayHead Amt.", path: "/admin/monthwise-payhead-amounts", icon: FaSortAmountUp },
      { label: " Generate Payroll", path: "/admin/generate-payroll", icon: IoIosCreate },
      { label: "Payroll Report", path: "/admin/payroll-report", icon: TbReport },
      { label: "Payhead Report", path: "/admin/payhead-report", icon: TbReport },
    ],
  },
  {
    key: "purchase",
    label: "Purchase",
    icon: BiPurchaseTagAlt,
    menus: [
      { label: "Enquiry", path: "/admin/purchase-enquiry", icon: FaSearch },
      { label: "Quotation", path: "/admin/quotation", icon: FaFileAlt },
      { label: "Order", path: "/admin/order", icon: FaCartFlatbedSuitcase },
      { label: "Purchase", path: "/admin/purchase", icon: FaShoppingCart },
      { label: "Return", path: "/admin/purchase-return", icon: MdAssignmentReturn },
      { label: " Document", path: "/admin/purchase-document", icon: GiBlackBook },
    ],
  },
  {
    key: "sales",
    label: "Sales",
    icon: RiBillLine,
    menus: [
      { label: "Sale Quotation", path: "/admin/sale-quotation", icon: HiOutlineDocumentReport },
      { label: "Performa Invoice", path: "/admin/performa-invoice", icon: MdOutlineSupportAgent },
      { label: "Sale Invoice", path: "/admin/sale-invoice", icon: HiOutlineDocumentReport },
      { label: "Delivery Challan", path: "/admin/delivery-challan", icon: HiOutlineDocumentReport },
      { label: "Sale Return", path: "/admin/sale-return", icon: HiOutlineDocumentReport },
           { label: "Report", path: "/admin/sale-report",icon:TbReport},
           { label: "Documents", path: "/admin/sale-document", icon: GiBlackBook },
    ],
  },
  {
    key: "services",
    label: "Services",
    icon: RiCustomerServiceFill,
    menus: [
       { label: "Call", path: "/admin/crm/complaint", icon: IoCall },
          { label: "Recharge", path: "/admin/crm/recharge", icon: FaMoneyBill },
          { label: "Vendor Calls", path: "/admin/crm/vendor-call", icon: TfiHeadphoneAlt },
          { label: "Service Schedule ", path: "/admin/generate-pms", icon: GrSchedulePlay },
          { label: "Service Report ", path: "/admin/service-report-pms", icon: TbReportSearch },
          { label: "Repair Quoattaion ", path: "/admin/repair-quoattaion", icon: MdOutlinePageview },
          { label: "Repair Invoice ", path: "/admin/repair-invoice", icon: HiOutlineDocumentReport },
          { label: " Document", path: "/admin/service-document", icon: GiBlackBook },
    ],
  },
  {
    key: "CRM",
    label: "CRM",
    icon: FaClipboardUser,
    menus: [
       { label: "FollowUp Status", path: "/admin/crm/followup-status", icon: SiStatuspage },
           { label: "FollowUp", path: "/admin/crm/followup", icon: MdFollowTheSigns },
           { label: "Sales Enquiry", path: "/admin/crm/sales-enquiry", icon: IoSearch },
           { label: "Add Data", path: "/admin/crm-bulk-data", icon: FaDatabase },
           { label: "CRM Report", path: "/admin/crm-report", icon: FaDatabase },
           { label: " Document", path: "/admin/crm-document", icon: GiBlackBook },

    ],
  },
  {
    key: "report",
    label: "Report",
    icon: TbReportSearch,
    menus: [
      { label: "inventory Report", path: "/admin/inventory-report", icon: TbReport },
      { label: "Attendence Report", path: "/admin/attendence-report", icon: BiSolidReport },
      { label: "Payroll Report", path: "/admin/payroll-report", icon: TbReport },
    ],
  },

   {
      key: "franchisee-admin",
      label: "Franchisee Admin",
      icon:FaClipboardUser,
      menus: [
            { label: "Denied Call", path: "/admin/denied-call" ,icon:HiOutlinePhoneMissedCall},
             { label: "Franchisee Area ", path: "/admin/franchisee-area" ,icon:PiMapPinAreaDuotone},
        
         
     ],
    },
  
    {
      key: "customer-care",
      label: "Customer Care",
      icon:FaClipboardUser,
      menus: [
            { label: "Customer Detail", path: "/admin/customer-care-detail" ,icon:GoChecklist}, 
              { label: "Verify Technician ", path: "/admin/customer-technician-verify", icon: GoChecklist },  
     ],
    },
    
    {
      key: "team-leader",
      label: "Team Leader",
      icon:RiAdminLine,
      menus: [
             { label: "All Call List ", path: "/admin/call-verify" ,icon:PiPhoneCallBold},      
     ],
    },
     {
      key: "telecaller",
      label: "Telecaller",
      icon:LuHeadset,
      menus: [
             { label: "Telecaller Call List ", path: "/admin/telecaller-call" ,icon:PiPhoneCallBold},      
     ],
    },
     {
      key: "AMC",
      label: "AMC",
      icon:RiRedPacketFill,
      menus: [
           { label: "AMC Quotation", path: "/admin/amc-quotation" ,icon:RiBillLine},
            { label: "AMC", path: "/admin/amc" ,icon:HiTemplate},
             { label: "AMC Report", path: "/admin/amc-report" ,icon:TbReportSearch },  
             { label: " Document", path: "/admin/amc-document", icon: GiBlackBook },  
     ],
    },
     {
      key: "warranty",
      label: "Warrantty",
      icon: IoTimerOutline,
      menus: [
        { label: "Warranty", path: "/addmin/warranty",icon:CiViewTimeline  },
          { label: "Warranty Report ", path: "/admin/warranty-report",icon:TbReportSearch },
          
     ],
    },
     {
      key: "production",
      label: "Production",
      icon:MdOutlineProductionQuantityLimits,
      menus: [
        { label:"Batch", path:'/admin/batch-master',icon:CiViewTimeline  },
        { label:"BOM", path:'/admin/bom-master',icon:SiMaterialdesignicons  },
         { label:"Production", path:'/admin/material-production',icon:TbBrandProducthunt  },
     ],
    },
     {
        key: "costing",
        label: "Costing",
        icon: RiMoneyRupeeCircleLine,
        menus: [
          { label: "Cost Center ", path: "/admin/cost-center", icon: FaCentercode },
          // { label: "Cost Category ", path: "/admin/cost-category" ,icon:HiMiniBuildingOffice2}, 
          { label: "Cost Center Link ", path: "/admin/cost-center-link", icon: GrLink },
        ],
      },
       {
          key: "report",
          label: "Report",
          icon: TbReportAnalytics,
          menus: [
            { label: "PF Report", path: "/admin/pf-report", icon: TbReportMoney },
            { label: "Costing Report", path: "/admin/costing-report", icon: TbReportMedical },
          ],
        },

];


